module.exports = __webpack_public_path__ + "img/label_2.af7fbf06.png";